var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetworkQuality = function SvgNetworkQuality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    baseProfile: "full",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.404,
    d: "M57 19v38h-6V19zm-8 8v30h-6V27zm-8 8v22h-6V35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 57v-6h6v6zm14-13v13h-6V44z"
  })));
};
export default SvgNetworkQuality;